import { BaseExtension } from "../extensions/baseExtension.js";
//#region src/transports/base.ts
var BaseTransport = class extends BaseExtension {
	isBatched() {
		return false;
	}
	getIgnoreUrls() {
		return [];
	}
};
//#endregion
export { BaseTransport };

//# sourceMappingURL=base.js.map